import { Injectable } from '@angular/core';
import { ExerciseType } from '../models/winco/exercise-type.model';
import { Replay } from '../models/winco/replay.model';
import { BetterScore } from '../models/winco/better-score.model';
import { HttpClientService } from './http-client.service';
import { EventManagerService } from 'event-manager';
import { NumberToTimePipe } from '../pipes/number-to-time.pipe';
import { AuthService } from 'auth';
import { SimpleResponse } from 'http-manager';

/**
 * Servicio que gestiona la reproducción de un ejercicio y su interacción con el usuario
 */
@Injectable({
  providedIn: 'root'
})
export class ExerciseService
{

  trackingCheck: boolean = true;
  exerciseTimeWhithoutTracking: any;
  totalTime: number;

  constructor(private clientService: HttpClientService,
              private authService:AuthService,
              private numberToTimePipe:NumberToTimePipe)
  { }

  /**
   * Convierte un número a formato minutos/segundos (00:00)
   * @param time Número que debe ser convertido
   * @returns Cadena de texto formateada
   */
  GetFormatTime(time: number)
  {
    return this.numberToTimePipe.transform(time);
  }

  /**
   * Elimina los elementos visuales que componen un ejercicio
   * @param exception Opcional. Componente que debe quedar exento de ser eliminado
   */
  public ClearExercise(exception:string = '')
  {
    const exercises = document.getElementsByTagName('app-exercise');
    const statistics = document.getElementsByTagName('app-exercise-results');

    if(exception != 'viewer')
      for (let i = 0; i < exercises.length; i++)
        exercises[i].parentElement.removeChild(exercises[i]);

    if(exception != 'statistics')
      for (let i = 0; i < statistics.length; i++)
        statistics[i].parentElement.removeChild(statistics[i]);
  }

  /**
   * Elimina los elementos visuales que componen un formulario de edición de ejercicio
   * @param exception Opcional. Componente que debe quedar exento de ser eliminado
   */
  public ClearForms(exception:string = '')
  {
    const list = document.getElementsByTagName('app-list');
    const edit = document.getElementsByTagName('app-edit');

    if(exception != 'list')
      for (let i = 0; i < list.length; i++)
        list[i].parentElement.removeChild(list[i]);

    if(exception != 'edit')
      for (let i = 0; i < edit.length; i++)
        edit[i].parentElement.removeChild(edit[i]);
  }

  /**
   * Obtiene la mejor puntuación de un usuario para un ejercicio
   * @param idExercise Identificador de ejercicio
   * @param idUser Identificador de usuario
   * @returns BetterScore - Datos de la puntuación
   */
  public GetBetterScore(idExercise: string, idUser: string): Promise<BetterScore>
  {
    return this.clientService.get<BetterScore>("Exercises/BetterScore/" + idExercise + '/' + idUser);
  }

  /**
   * Obtiene la lista de tipos de ejercicio
   * @returns ExerciseType[] - Lista de tipos de ejercicio
   */
  public GetExerciseType(): Promise<ExerciseType[]>
  {
    return this.clientService.get<ExerciseType[]>("Exercises/ExercisesTypes");
  }

  getProgressStudent(): Promise<number>
  {
    return new Promise<number>((resolve) =>
      this.clientService.get<SimpleResponse>("Replays/ProgressStudent", this.authService.getUser().uuid)
                        .then(response  => resolve(Number(response.message)))
                        .catch(() => resolve(0)));
  }

  /**
   * Guarda los datos de un intento de usuario
   * @param data Datos del intento
   * @returns Replay - Datos del intento actualizados
   */
  public SaveReplay(data: Replay): Promise<Replay>
  {
    return this.clientService.post<Replay>("Replays/SaveData", data);
  }
}
